import { getTrueDate } from '@/lib/utils';
import { Card } from '@/shared/ui/card.tsx';
import { Separator } from '@/shared/ui/separator.tsx';
import { IconCircle, IconCircleCheckFilled } from '@tabler/icons-react';

type TimelineCardProps = {
  isPosted: boolean;
  post_title: string;
  posting_date: string;
  platform: string;
}

const TimelineCard = ({ posting_date, post_title, isPosted, platform }: TimelineCardProps) => {

  const social = platform.toLowerCase().includes("twitter") ? "x" : platform.toLowerCase()

  return (
    <Card className='flex items-start w-full bg-white/70 justify-between gap-4 p-3 pb-0 relative'>
      <img src={`https://cdn.simpleicons.org/${social}`} className="absolute bottom-1 right-1 h-3 w-3" />
      <div className='flex flex-col items-center'>
        {isPosted ? <IconCircleCheckFilled className='text-green-500' /> :
          <IconCircle className='text-yellow-400' stroke="4px" />
        }
        <Separator orientation='vertical' className={`h-7 ${!isPosted ? "bg-yellow-400" : "bg-green-400" } w-[2px]`} />
      </div>
      <div className='flex flex-col gap-1 flex-1 pb-2'>
        <p className='font-comfortaa tracking-wide text-sm'>{post_title}</p>
        <p className='font-poppins text-xs font-semibold'>{getTrueDate(posting_date, 'PP')}</p>
      </div>
    </Card>
  )
}

export default TimelineCard;
